import { Oval, ThreeDots } from "react-loader-spinner";

export const LoadingLoader = ({ height = 25, width = 25 }) => (
  <Oval
    height={height}
    width={width}
    color="white"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="oval-loading"
    secondaryColor="#4fa94d"
    strokeWidth={2}
    strokeWidthSecondary={2}
  />
);

export const LoadingThreeDots = ({ height = 25, width = 50 }) => (
  <ThreeDots
    height={height}
    width={width}
    radius="7"
    color="#4fa94d"
    ariaLabel="three-dots-loading"
    wrapperStyle={{}}
    wrapperClassName=""
    visible={true}
  />
);

export const LoadingElectricity = ({ size = 90, color = "blue" }) => (
  <div className="flex justify-center items-center min-h-screen">
    <l-cardio size={size} stroke="5" speed="2" color={color}></l-cardio>
  </div>
);

export const LoadingElectricityTwo = ({ size = 90, color = "blue" }) => (
  <div className="flex justify-center items-center ">
    <l-cardio size={size} stroke="5" speed="2" color={color}></l-cardio>
  </div>
);

export const getColorByStatusForFire = (status) => {
  switch (status) {
    case "ON":
      return "border-2 bg-green-500 border-green-500 text-green-500 text-white";
    case "OFF":
      return "border-2 bg-red-500 border-red-500 text-red-500  text-white animate-blink ";
    case "TRIP":
      return "border-2 bg-red-500 border-red-500 text-red-500  text-white animate-blink";
    case null:
      return "border-2 border-red-500  text-white-500  animate-blink  text-white";
    default:
      return "bg-gray-400  text-white";
  }
};
export const getColorByStatus = (status) => {
  switch (status) {
    case "ON":
      return "border-2 border-green-500 shadow-lg shadow-green-500/50 text-green-500";
    case "OFF":
      return "border-2 border-red-500 shadow-lg shadow-red-500/50 text-red-500";
    case "TRIP":
      return "border-2 border-orange-500 shadow-lg shadow-orange-500/50 text-orange-500  animate-blink";
    case null:
      return "border-2 border-red-500 shadow-lg shadow-red-500/50 text-white-500  animate-blink";
    default:
      return "bg-gray-400";
  }
};
export const getStatusForFour = (status) => {
  switch (status) {
    case "ON":
      return "CLOSED";
    case "OFF":
      return "OPEN";
    case "TRIP":
      return "TRIPPED";
    case null:
      return "N/A";
    default:
      return "N/A";
  }
};
export const getStatusForFourGenerator = (status) => {
  switch (status) {
    case "ON":
      return "RUNNING";
    case "OFF":
      return "STAND BY";
    case "TRIP":
      return "TRIPPED";
    case null:
      return "STAND BY";
    default:
      return "STAND BY";
  }
};
export const getColorByStatusTitle = (status) => {
  switch (status) {
    case "ON":
      return "text-green-500 font-semibold";
    case "OFF":
      return "text-red-500 font-semibold ";
    case "TRIP":
      return "text-orange-500 font-semibold";
    default:
      return "bg-gray-400";
  }
};
